// import  foto from './images/image-emily.jpg'
export const testimonials = [
  {
    id: 1,
    image: require("./images/image-emily.jpg"),
    name: "Emily R.",
    desc: "We put our trust in Sunnyside and they delivered, making sure our needs were met and deadlines were always hit.",
    title: "Marketing Director",
  },
  {
    id: 2,
    image: require("./images/image-thomas.jpg"),
    name: "Thomas S.",
    desc: "Sunnyside’s enthusiasm coupled with their keen interest in our brand’s success made it a satisfying and enjoyable experience.",
    title: "Chief Operating Officer",
  },
  {
    id: 3,
    image: require("./images/image-jennie.jpg"),
    name: "Jennie F.",
    desc: "Incredible end result! Our sales increased over 400% when we worked with Sunnyside. Highly recommended!",
    title: "Business Owner",
  },
]
